import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  UPDATE_USER_LIST,
  FETCH_USER_LIST,
  FETCH_BRAND_LIST,
  SET_USER_LIST,
} from "../store/admin";

import CLoader from "../components/shared/CLoader";
import UsersTable from "../components/admin/UsersTable";

const _ADMIN_ROLES = new Set(['spclty_hub_admin', 'spclty_hub_super_admin']);

const Userprofile = ()=>{
    const dispatch = useDispatch();

    const { roles, user: userData } = useSelector(({ user }) => user);
    const isAdmin = roles?.some(r => _ADMIN_ROLES.has(r));

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
      dispatch(FETCH_BRAND_LIST());
      if (isAdmin) {
        dispatch(FETCH_USER_LIST());
      } else if (userData && userData.email_id) {
        const entries = (userData.role || []).map(role => {
          const brandStr = userData.brand?.[role] || '';
          const brandArray = brandStr.toUpperCase() === 'ALL'
            ? ['ALL']
            : brandStr.split(',').map(b => b.trim().toUpperCase()).filter(Boolean);
          const roleUuid = userData.role_uuid?.[role] || userData.uuid;
          return { ...userData, uuid: roleUuid, role, brand: brandArray, isSelected: false, isVisible: true };
        });
        dispatch(SET_USER_LIST(entries));
      }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const { loading } = useSelector(({ admin }) => admin);
    const { uuid } = useSelector(({ user }) => user.user || {});
    const {emailId} = useSelector(({user}) => user || '');

    const saveUserListForm = async (obj) => {
        if (Array.isArray(obj)) {
          obj.forEach((object) => {
            delete object["isSelected"];
            delete object["isVisible"];
          });
        } else {
          delete obj.isVisible;
          delete obj.isSelected;
        }
        const updateUserDetails = {
          users: Array.isArray(obj) ? obj : [obj],
          updated_by: uuid,
        };
        return await dispatch(UPDATE_USER_LIST(updateUserDetails));
      };

    return <>  {loading && <CLoader size={90} />}
    {!loading && (
      <UsersTable
        saveUserListForm={saveUserListForm}
        searchText={emailId}
        isProfile={true}
      ></UsersTable>
    )}</>
};

export default Userprofile;